export const ContentType = {
  Component: 0,
  Helper: 1,
  String: 2,
  Empty: 3,
  SafeString: 4,
  Fragment: 5,
  Node: 6,
  Other: 8,
} as const;
